import * as React from 'react';

import styles from './email-address-field.module.css';

type Props = {
    label: string;
    value: string;
};

export const EmailAddressField = (props: Props) => {
    return (
        <div className={styles.container}>
            <div className={styles.label}>{props.label}</div>
            <div>{props.value}</div>
        </div>
    );
};
